export const DRAG_VERIFY_STATUS = {
  IN_PROGRESS: "inProgress",
  FULL_FILLED: "fullFilled",
  TO_DO: "todo",
};
export const PASS_ICON = {
  HIDDEN_PASS: "eye-slash-icon",
  REVEAL_HIDDEN_PASS: "eye-icon",
};

// export const hiddenPages = ["/password-reset-gmail", "/new-password-reset", "/sign-up", "/sign-in", "/get-quote", "/get-quote/confirmation", "/vps-hosting/purchase", "/vps-hosting/purchase/confirmation", "/web-hosting/purchase", "/domain/purchase", "/domain/purchase/configuration", "/domain/purchase/configuration/confirmation", "/dedicated-server/purchase", "/dedicated-server/purchase/confirmation", "/terms"];

export const ALERTS_SETS = {
  UPDATED_PASSWORD:
    "Your password has been updated. You can sign in your account with the password sent to your email address.",
  SIGN_UP:
    "Thank you for signing up. Please activate your account by entering the activation link we sent to your email address to complete your registration.",
  ACCOUNT_ACTIVATED:
    "Your account has been activated. You can use our services by entering your e-mail address and password.",
  NEW_PASSWORD_EMAIL:
    "We have sent your new password to your email address. You can use your password by entering the confirmation link.",
  CONTACT_SENT: "Your messages successfully was sent!",
  GOT_WRONG: "Someting went wrong, please try again!",
  WRONG_DETAILS:
    "The details you entered seem to be incorrect. If you signed up via social login, please use social login when signing in.",
  // INFO_NS: t("infoDomain"),
  NO_BALANCE:
    "Please ensure your balance has sufficient funds by adding money.",
  SUCCESS_QUOTE: "Your quote was successfully sent!",
  JOBLİST_FETCH_ERROR: "Something went wrong during fetching job positions",
};

export const questionMarkElements = [
  "Websites",
  "Parked Domains",
  "Subdomains per account",
  "1-Click Installer",
  "Hotlink Protection",
  "SSH Access",
  "Free SSL Certificate",
  "99.9% Uptime Guarantee",
];

export const regions = [
  {
    id: "auto",
    name: "Auto",
  },
  {
    id: "uk",
    name: "Ukraine",
  },
];

export const OS_Versions = [
  {
    os: "ubuntu",
    versions: [
      {
        id: "111",
        name: "Ubuntu 16.04 64-bit",
      },
      {
        id: "112",
        name: "Ubuntu 18.04 64-bit",
      },
      {
        id: "113",
        name: "Ubuntu 20.04 64-bit",
      },
      {
        id: "114",
        name: "Ubuntu 22.04 64-bit",
      },
    ],
  },
  {
    os: "debian",
    versions: [
      {
        id: "222",
        name: "Debian 8 64-bit",
      },
      {
        id: "223",
        name: "Debian 9 64-bit",
      },
      {
        id: "224",
        name: "Debian 10 64-bit",
      },
      {
        id: "225",
        name: "Debian 11 64-bit",
      },
    ],
  },
  {
    os: "opensuse",
    versions: [
      {
        id: "333",
        name: "OpenSUSE 15.4 64-bit",
      },
    ],
  },
  {
    os: "centos",
    versions: [
      {
        id: "444",
        name: "CentOS 6 64-bit",
      },
      {
        id: "445",
        name: "CentOS 7 64-bit",
      },
      {
        id: "446",
        name: "CentOS 8 64-bit",
      },
      {
        id: "447",
        name: "CentOS 9 64-bit",
      },
    ],
  },
];

export const osData = [
  {
    id: "111",
    name: "Ubuntu 16.04 64-bit",
  },
  {
    id: "112",
    name: "Ubuntu 18.04 64-bit",
  },
  {
    id: "113",
    name: "Ubuntu 20.04 64-bit",
  },
  {
    id: "114",
    name: "Ubuntu 22.04 64-bit",
  },
  {
    id: "222",
    name: "Debian 8 64-bit",
  },
  {
    id: "223",
    name: "Debian 9 64-bit",
  },
  {
    id: "224",
    name: "Debian 10 64-bit",
  },
  {
    id: "225",
    name: "Debian 11 64-bit",
  },
  {
    id: "333",
    name: "OpenSUSE 15.4 64-bit",
  },
  {
    id: "444",
    name: "CentOS 6 64-bit",
  },
  {
    id: "445",
    name: "CentOS 7 64-bit",
  },
  {
    id: "446",
    name: "CentOS 8 64-bit",
  },
  {
    id: "447",
    name: "CentOS 9 64-bit",
  },
];

export const storage = [
  {
    id: "fuhi2347g",
    name: "32 GB",
  },
  {
    id: "hf23f23",
    name: "64 GB",
  },
];

export const memories = [
  {
    id: "ifh238gf",
    name: "3 GB",
  },
  {
    id: "fnjwieuf",
    name: "5 GB",
  },
];

export const cpu = [
  {
    id: "jnfug84",
    name: "1 Core",
  },
  {
    id: "io43u2g8",
    name: "2 Core",
  },
  {
    id: "837g3hf38",
    name: "3 Core",
  },
  {
    id: "fjhqeif3",
    name: "4 Core",
  },
  {
    id: "jdhui3wgf",
    name: "5 Core",
  },
  {
    id: "fh3g489hg4",
    name: "6 Core",
  },
  {
    id: "83uyt934hg",
    name: "7 Core",
  },
  {
    id: "haskfubw34",
    name: "8 Core",
  },
  {
    id: "hufh32948",
    name: "9 Core",
  },
  {
    id: "bvzzbuibre",
    name: "10 Core",
  },
  {
    id: "bxvjjfhef3",
    name: "11 Core",
  },
  {
    id: "nviusdbu43",
    name: "12 Core",
  },
  {
    id: "7834gf3gf9",
    name: "13 Core",
  },
  {
    id: "jhsafbi398",
    name: "14 Core",
  },
  {
    id: "8yfwehfkr",
    name: "15 Core",
  },
  {
    id: "hshgewr93",
    name: "16 Core",
  },
];

export const bandwidth = [
  {
    id: "3f9u823",
    name: "2 TB",
  },
  {
    id: "o3if324u",
    name: "3 TB",
  },
];

export const ipv4 = [
  {
    id: "73gg23fhg",
    name: "1 IP",
  },
  {
    id: "74yegjohif",
    name: "2 IP",
  },
];

export const ERROR_MESSAGES = {
  WENT_WRONG: "Something went wrong!",
  NOT_A_ROBOT: "Please verify that you are not robot!",
  NOT_DOMAIN_NAME: "Doman's name is not written",
};

export const Periods = [
  {
    id: 1,
    value: 1,
    title: "month",
  },
  {
    id: 2,
    value: 2,
    title: "inc_months",
  },
  {
    id: 3,
    value: 3,
    title: "inc_months",
  },
  {
    id: 4,
    value: 4,
    title: "inc_months",
  },
  {
    id: 5,
    value: 5,
    title: "inc_months",
  },
  {
    id: 6,
    value: 6,
    title: "inc_months",
  },
  {
    id: 12,
    value: 1,
    title: "year",
  },
  {
    id: 24,
    value: 2,
    title: "inc_years",
  },
  {
    id: 36,
    value: 3,
    title: "inc_years",
  },
];

export const currencyList = [
  {
    id: "USD",
    name: "USD",
  },
  {
    id: "AZN",
    name: "AZN",
  },
];

export const languages = [
  {
    id: "az",
    name: "AZ",
  },
  {
    id: "en",
    name: "EN",
  },
];
export const statusStyles = {
  6: { style: "#15803d", backgroundColor: "#dcfce7" },
  5: { style: "#eab308", backgroundColor: "#fef9c3" },
  7: { style: "#4b5563", backgroundColor: "#f3f4f6" },
};

export const statuses = {
  6: "completed",
  5: "progress",
  7: "notStarted",
};


export const siteInfo = {
  defaultLanguage: {
    'sayt.az': 'az',
    'websiteca.com': 'en'
  },
  defaultCurrency: {
    'sayt.az': 'AZN',
    'websiteca.com': 'USD'
  },
  app_id: {
    'sayt.az': 1220264511993319,
    'websiteca.com': 485315707307064
  },
  WEBSITE_TITLE: {
    'sayt.az': 'Sayt.az',
    'websiteca.com': 'WebsiteCA'
  },
  WEBSITE_URL: {
    'sayt.az': 'https://sayt.az',
    'websiteca.com': 'https://websiteca.com'
  },
  WEBSITE_PHONE: {
    'sayt.az': '+(99470) 330-00-04',
    'websiteca.com': '(323) 333-5535'
  },
  WEBSITE_ADDRESS: {
    'sayt.az': 'Yasamal r-nu, Şərifzadə küç. 233/15. 4-cü mərtəbə',
    'websiteca.com': '2717 Commercial Center Blvd, STE 200, Katy, TX 77494'
  },
  WEBSITE_EMAIL: {
    'sayt.az': "support@sayt.az",
    'websiteca.com': 'support@websiteca.com'
  }

}

export const currency_icon = {
  'AZN': "₼",
  'USD': "$"
}